import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Zoom from 'react-medium-image-zoom';

import getCSSSelector_1 from '../../../../../libraries/Images/getCSSSelector_1.png';
import getCSSSelector_2 from '../../../../../libraries/Images/getCSSSelector_2.png';
import getCSSSelector_3 from '../../../../../libraries/Images/getCSSSelector_3.png';
import getCSSSelector_4 from '../../../../../libraries/Images/getCSSSelector_4.png';

import makeYourFirstRobot_1 from '../../../../../libraries/Images/makeYourFirstRobot_1.png';
import makeYourFirstRobot_2 from '../../../../../libraries/Images/makeYourFirstRobot_2.png';
import makeYourFirstRobot_3 from '../../../../../libraries/Images/makeYourFirstRobot_3.gif';
import makeYourFirstRobot_4 from '../../../../../libraries/Images/makeYourFirstRobot_4.png';
import makeYourFirstRobot_5 from '../../../../../libraries/Images/makeYourFirstRobot_5.png';
import makeYourFirstRobot_6 from '../../../../../libraries/Images/makeYourFirstRobot_6.png';
import makeYourFirstRobot_7 from '../../../../../libraries/Images/makeYourFirstRobot_7.png';

import runYourRobot_1 from '../../../../../libraries/Images/runYourRobot_1.png';
import runYourRobot_2 from '../../../../../libraries/Images/runYourRobot_2.png';

import scheduleRobotRun_1 from '../../../../../libraries/Images/scheduleRobotRun_1.png';
import scheduleRobotRun_2 from '../../../../../libraries/Images/scheduleRobotRun_2.png';
import scheduleRobotRun_3 from '../../../../../libraries/Images/scheduleRobotRun_3.png';
import scheduleRobotRun_4 from '../../../../../libraries/Images/scheduleRobotRun_4.png';
import scheduleRobotRun_5 from '../../../../../libraries/Images/scheduleRobotRun_5.png';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="getcssselector">
                1. {translate('getcssselector')}
            </Typography>
            <p>CSS セレクターは、パーティーに参加する人々の名札のようなものです。</p>
            <p>名札が人でいっぱいの部屋の中で特定の人を識別するのと同じように、CSS セレクターは、Web ページ上の HTML 要素を識別するために利用されます。CSS セレクターを利用することで、RPA CLOUDのWebブラウザ機能を利用してWebサイト上の作業を自動化できます。</p>
            <p>まず、Chrome に「RPA CLOUD」 拡張機能をインストールする必要があります。ンストール手順については、<Box component={Link} to='/control-center/documentation/gettingstarted/installation/#chrome-extension'>こちら</Box> を参照してください。</p>
            <p>手順：</p>
            <ol>
                <li>Web ページを開きます。</li>
                <p>たとえば、amazon webページを開きます。 <a href="https://www.amazon.com/" target="_blank">https://www.amazon.com/</a>.</p>
                <Zoom>
                    <img src={getCSSSelector_1} width="75%" />
                </Zoom>
                <li>取得したい要素を右クリックします。</li>
                <p>[検索]フィールドのCSSセレクターを取得したい場合、[検索バー]の位置に移動して右クリックします。</p>
                <Zoom>
                    <img src={getCSSSelector_2} width="75%" />
                </Zoom>
                <li>コンテキストメニューから[Copy CSS Selector] をクリックします。</li>
                <p>[Copy CSS Selector] をクリックすると、要素に青い枠線が表示されます。この青い枠線は、CSS セレクターが正常に取得されたことを示します。</p>
                <Zoom>
                    <img src={getCSSSelector_3} width="75%" />
                </Zoom>
                <li>コピーした CSS セレクターを貼り付けて確認します。</li>
                <p>最後にテキストエディタ (Windows: [Ctrl]+[V] / Mac: [Command]+[V])に貼り付けます。 CSS セレクターが正常に取得されたことがわかります。</p>
                <Zoom>
                    <img src={getCSSSelector_4} width="75%" />
                </Zoom>
            </ol>
            <Typography variant="h5" gutterBottom id="makeyourfirstrobot">
                2. {translate('makeyourfirstrobot')}
            </Typography>
            <p>たとえば、Amazon ウェブサイトで iPhone の商品を検索するロボットを作成してみましょう。</p>
            <p>手順：</p>
            <ol>
                <li>まず、 <a href="/control-center/workspace" target="_blank">こちら</a>をクリックしてロボットを作成します。</li>
                <li>次に、[新規追加]ボタンをクリックし、以下のフィールドに入力します。</li>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_1} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;プロジェクト名を選択します。プロジェクトがない場合は、左側の ➕ ボタン (❶a) をクリックしてプロジェクトを作成します。</li>
                    <li>❷&nbsp;ロボット名を入力します。</li>
                    <li>❸&nbsp;ロボットのアイコンを選択します。</li>
                    <li>❹&nbsp;ロボットの背景色を選択します。</li>
                    <li>❺&nbsp;ロボットのアイコンの色を選択します。</li>
                    <li>❻&nbsp;エラー発生時のメール送信を「いいえ」か「はい」かを選択します。</li>
                    <li>❼&nbsp;ロボットの説明を入力します。</li>
                    <p> [OK] ボタンをクリックして終了します。</p>
                </ul>
                <li>ロボットの作成が成功すると、ロボットのカードが表示されます (ロボットごとに 1 枚のカード)。.</li>
                <p>レンチ ボタンをクリックして、ロボットのスクリプトを作成します。</p>
                <Zoom>
                    <img src={makeYourFirstRobot_2} width="75%" />
                </Zoom>
                <li>[ブラウザの開き]のアクションを構築するには</li>
                <p>[ブラウザの開き]を押したままドラッグします。</p>
                <Zoom>
                    <img src={makeYourFirstRobot_3} width="75%" />
                </Zoom>
                <p>ターゲット Web サイトの URL を入力します。</p>
                <p>歯車アイコンをクリックしてオプション ボックスを開き、[URL] フィールドに Amazon Web サイトのリンクを入力します。最後に[保存]ボタンをクリックして変更を保存します。</p>
                <Zoom>
                    <img src={makeYourFirstRobot_4} width="75%" />
                </Zoom>
                <li>[テキストを入力]のアクションを構築するには</li>
                <p>Amazon ウェブサイトの検索フィールドに「iphone 13 pro max」というテキストを入力したい、次の手順に従います。</p>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_5} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;[テキスト入力]アを押したままドラッグします。</li>
                    <li>❷&nbsp;歯車アイコンをクリックしてオプション ボックスを開きます。</li>
                    <li>❸&nbsp;テキストを入力する対象の Web サイトを選択します。複数の Web サイトを開いている場合、各 Web サイトは特定の出力キーに対応します。</li>
                    <li>❹&nbsp;Amazon ウェブサイトを開き、テキスト入力フィールドの CSS セレクターをコピーして、ここに貼り付けます。</li>
                    <li>❺&nbsp;テキスト フィールドに希望のテキスト (この例では「iphone 13 pro max」) を入力します。</li>
                    <p>最後に、[保存]ボタンをクリックしてアクションを保存します。</p>
                </ul>
                <li>[クリック]のアクションを構築するには</li>
                <p>Amazon ウェブサイト上検索ボタンをクリックします。</p>
                <ul style={{ listStyle: "none" }}>
                    <Zoom>
                        <img src={makeYourFirstRobot_6} width="75%" />
                    </Zoom>
                    <li>❶&nbsp;[クリック]アクションを押したままドラッグします。</li>
                    <li>❷&nbsp;歯車アイコンをクリックしてオプション ボックスを開きます。</li>
                    <li>❸&nbsp;クリックする対象の Web サイトを選択します。複数の Web サイトを開いている場合、各 Web サイトは特定の出力キーに対応します。</li>
                    <li>❹&nbsp;Amazon ウェブサイトを開き、クリックしたい位置のCSSセレクターをコピーして,ここに貼り付けます。</li>
                    <p>最後に、[保存]ボタンをクリックしてアクションを保存します。</p>
                </ul>
                <li>ロボットのスクリプトを保存します。</li>
                <p>[保存]ボタンをクリックしてロボットのスクリプトを保存します。 「保存」ボタンをクリックしないと、ページをリロードするとスクリプトは保存されません。</p>
                <Zoom>
                    <img src={makeYourFirstRobot_7} width="75%" />
                </Zoom>
            </ol>
            <Typography variant="h5" gutterBottom id="runyourrobot">
                3. {translate('runyourrobot')}
            </Typography>
            <p>以下の手順でロボットが正常に動作するか確認できます。</p>
            <p>手順：</p>
            <ol>
                <li>[実行]ボタンをクリックしてロボットを実行します。</li>
                <Zoom>
                    <img src={runYourRobot_1} width="75%" />
                </Zoom>
                <li>結果を確認します。</li>
                <p>Webブラウザ上で実行したアクションでは、[スクリーンショットを撮る]をオンにすると画像を含む結果を確認できます。</p>
                <Zoom>
                    <img src={runYourRobot_2} width="75%" />
                </Zoom>
                <p>ロボット作成ページに戻るには、右上の ✖️ をクリックします。</p>
            </ol>
            <Typography variant="h5" gutterBottom id="schedulerobotrun">
                4. {translate('schedulerobotrun')}
            </Typography>
            <p>ロボット実行スケジュール設定します。</p>
            <p>手順：</p>
            <ol>
                <li><a href="/control-center/schedule" target="_blank">こちら</a> クリックしてロボットのスケジュールを設定します。</li>
                <li>［新規追加］ボタンをクリックします。</li>
                <p>[次へ]ボタンをクリックします。</p>
                <Zoom>
                    <img src={scheduleRobotRun_1} width="75%" />
                </Zoom>
                <li>タイムゾーンを設定し、[次へ]ボタンをクリックします。</li>
                <Zoom>
                    <img src={scheduleRobotRun_2} width="75%" />
                </Zoom>
                <li>スケジュールを確認し、[OK]ボタンをクリックします。</li>
                <Zoom>
                    <img src={scheduleRobotRun_3} width="75%" />
                </Zoom>
                <li>スケジュールを設定すると、レコードが 1 つ表示されます (1 つのレコードが 1 つのスケジュールに相当します)。</li>
                <Zoom>
                    <img src={scheduleRobotRun_4} width="75%" />
                </Zoom>
                <p>スケジュールの履歴を確認または削除するには、対象のスケジュールにチェックを入れ、オプションを選択します。</p>
                <Zoom>
                    <img src={scheduleRobotRun_5} width="75%" />
                </Zoom>
            </ol>
        </Box>
    );
}
export default withTranslate(En);